import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.initializeDropdowns();
  }

  initializeDropdowns() {
    const $ = window.jQuery || window.$;
    if (!$ || !$.fn.dropdown) return;

    this.element.querySelectorAll('[data-toggle="dropdown"]').forEach((toggle) => {
      $(toggle).dropdown();
    });
  }
}
